// extracted by mini-css-extract-plugin
module.exports = {"error":"error___3hieM","flex-grid":"flex-grid___2IwLm"};